import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';

var _templateObject;
var RadioText = styled('span')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: ", ";\n  margin-left: ", ";\n  &[disabled] {\n    opacity: 0.3;\n  }\n"])), function (_ref) {
  var hideLabel = _ref.hideLabel;
  return hideLabel ? 'none' : undefined;
}, function (_ref2) {
  var hideLabel = _ref2.hideLabel;
  return !hideLabel ? '1.5rem' : undefined;
});

export default RadioText;
